
import { Route, Routes } from "react-router-dom";
import ErrorPage from "../../pages/ErrorPage";
import BusinessProfile from "../../pages/business/BusinessProfile";
import ModernBusinessDashboard from "../../pages/business/ModernBusinessDashboard";
import Assistant from "../../pages/assistant/Assistant";
import SolidityScan from "../../pages/business/SolidityScan";
import ProgramEditor from "../../pages/programs/ProgramEditorRouter";
import PaginatedTransactions from "../../pages/payments/PaginatedTransactions";
import InvitationsManager from "../../components/users/InvitationManager";
import BusinessChecklistView from "../../pages/business/BusinessChecklistView";
import PaginatedPrograms from "../../pages/programs/PaginatedPrograms";
import ProgramPage from "../../pages/programs/ProgramPage";
import PaginatedReports from "../../pages/reports/PaginatedReports";
import ReportPage from "../../pages/reports/ReportPage";
import RetestManagement from "../../pages/retests/RetestManagent";
import ProgramFeedbackPage from "../../pages/programs/ProgramFeedbackPage";
import RetestPage from "../../pages/retests/RetestPage";
import PentestReports from "../../pages/automated-report/PentestReports";
import OrgSettingsPage from "../../pages/settings/OrgSettingsPage";
import BusinessPentestReportGuard from "../../components/routes/BusinessPentestReportGuard";
import CredentialVaultPage from "../../pages/business/CredentialVaultPage";
import CredentialVaultGuidePage from "../../pages/business/CredentialVaultGuidePage";
import BusinessResearcherProfile from "../../pages/researcher/BusinessProfile";
import CreateAssetPage from "../../pages/Assets/CreateAsset/CreateAssetPage";
import AssetInventoryPage from "../../pages/Assets/AssetInventoryPage";
import AssetDetailPage from "../../pages/Assets/AssetDetailPage";
import OnboardingDocumentationRoutes from "./OnboardingDocumentationRoutes";
import SubscriptionHistory from "../../pages/business/SubscriptionHistory";
import SubscriptionDetails from "../../pages/business/SubscriptionDetails";
import BusinessScopingGate from "../../components/routes/BusinessScopingGate";
import NotificationsPage from "../../pages/notifications/NotificationsPage";

const BusinessRoutes = () => {
  return (
    <BusinessScopingGate>
      <Routes>
        <Route index element={<ModernBusinessDashboard />} />

        <Route path="programs/:id/edit" element={<ProgramEditor />} />
        <Route path="create-program" element={<ProgramEditor />} />
        <Route path="invitation" element={<InvitationsManager />} />

        <Route path="profile/*" element={<BusinessProfile />} />
        <Route path="settings/*" element={<OrgSettingsPage />} />
        <Route path="vault" element={<CredentialVaultPage />} />
        <Route path="vault/guide" element={<CredentialVaultGuidePage />} />
        <Route path="reports" element={<PaginatedReports />} />
        <Route path="reports/:id" element={<ReportPage />} />
        <Route path="assets" element={<AssetInventoryPage />} />
        <Route path="assets/:id" element={<AssetDetailPage />} />
        <Route path="assets/create/:id?" element={<CreateAssetPage />} />
        <Route path="subscription" element={<SubscriptionHistory />} />
        <Route path="subscriptions" element={<SubscriptionHistory />} />
        <Route path="subscription-history" element={<SubscriptionHistory />} />
        <Route path="subscription/:subscriptionId" element={<SubscriptionDetails />} />
        <Route path="subscriptions/:subscriptionId" element={<SubscriptionDetails />} />


        <Route path="programs" element={<PaginatedPrograms />} />
        <Route path="programs/:id" element={<ProgramPage />} />
        <Route path="programs/:id/feedback" element={<ProgramFeedbackPage />} />
        <Route path="programs/:programId/checklists/:checklistId" element={<BusinessChecklistView />} />
        <Route path="programs/:programId/runs/:runId/checklists/:checklistId" element={<BusinessChecklistView />} />


        <Route path="retests" element={<RetestManagement />} />
        <Route path="retests/:retest_id" element={<RetestPage />} />

        <Route path="assistant/*" element={<Assistant />} />
        <Route path="solidity-scan" element={<SolidityScan />} />
        <Route path="payments/*" element={<PaginatedTransactions />} />
        <Route path="pentest-reports" element={<PentestReports />} />
        <Route path="pentest-reports/:report_id/edit" element={<BusinessPentestReportGuard />} />
        <Route path="notifications" element={<NotificationsPage />} />

        <Route path="users/researcher-profile/:username" element={<BusinessResearcherProfile />} />
        <Route path="onboarding-documentation/*" element={<OnboardingDocumentationRoutes />} />
        <Route path="/*" element={<ErrorPage />} />
      </Routes>
    </BusinessScopingGate>
  );
};

export default BusinessRoutes;
